/*!
 * Main application
 *
 */

(function($){

  $(document).ready(function() {

    let footerPos = $('#footer').position();

    /**
     * Sticky navigation
     */
    $(window).on('scroll', function(event) {
      var scrollValue = $(window).scrollTop();
      if (scrollValue > 70) {
        $('#header .navbar').addClass('sticky');
      } else {
        $('#header .navbar').removeClass('sticky');
      }

      // sharing icons in article
      if (scrollValue > 700) {
        $('.article .social-icons-blue').addClass('sticky');
      } else {
        $('.article .social-icons-blue').removeClass('sticky');
      }

      // remove logo in header when it scrolls into footer
      if (scrollValue > (footerPos.top - 120)) {
        $('#header .logo').addClass('remove');
      } else {
        $('#header .logo').removeClass('remove');
      }
    });

    /**
     * Main navigation toggle
     *
     */
    $('#menuMain').on('hidden.bs.collapse', function () {
      if ( !$(this).hasClass('show') ) {
        $('#header .logo').removeClass('d-none d-lg-block');
      }
    })

    $('#menuMain').on('show.bs.collapse', function () {
      $('#header .logo').addClass('d-none d-lg-block');
    })

    /**
     * Search toggle
     *
     */
    $('#search').on('hidden.bs.collapse', function () {
      $('body').removeClass('noscroll');
      $('#searchButton').focus();
    })

    $('#search').on('show.bs.collapse', function () {
      setTimeout(function() {
        $('#searchInput').focus();
        $('body').addClass('noscroll');
      }, 500);
    })

    /**
     * If hash is provided, scroll to position
     * start scrolling after a second, otherwise content might
     * not be loaded and position can't be detected
     *
     */
    setTimeout(function() {
      if (window.location.hash) {
        urlHash();
      }
    }, 1000);

    $(window).on('hashchange', function(e) {
      urlHash();
    });

    // smooth scroll to the anchor id
    let urlHash = function() {
      $('html, body').animate({
        scrollTop: ($(window.location.hash).offset().top) - 140
      }, 1000, 'swing');
    }

    /**
     * Slick slider
     */
    $('.news .Slider .hfeed').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 1300,
      centerMode: true,
      centerPadding: '0px',
      slidesToShow: 3,
      variableWidth: true,
      dots: true,
      arrows: true,
      responsive: [
        /*
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 3
          }
        },
         */
        {
          breakpoint: 768,
          settings: {
            infinite: true,
            slidesToShow: 1,
            variableWidth: false,
            adaptiveHeight: true,
            dots: true,
            arrows: false,
          }
        }
      ]
    });

    $('.slider').slick({
      dots: true,
      adaptiveHeight: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          }
        }
      ]
    });

    /**
     * Video privacy layer
     */
    $('.ce-textpic .privacy-layer').click(function() {
      let video = $(this).closest('.video'),
        iframeWrapper = video.find('.iframe-wrapper'),
        iframe = video.find('iframe'),
        figure = video.find('figure');

      $(this).removeClass('d-flex').hide();
      figure.addClass('d-none');
      iframeWrapper.removeClass('d-none');
      iframe.attr('src', iframe.attr('data-src'));
    });

    /**
     * Twitter privacy layer
     */
    $('.tweet').click(function() {
      $(this).html( $(this).attr('data-content') );
    });
  });

})(jQuery);

/**
 * Hide header on scroll down & show on scroll up
 * @todo: Not needed anymore? Remove!
 *
 * Thanks to https://codingreflections.com/hide-header-on-scroll-down/
 */
/*
(function(){
  document.addEventListener("DOMContentLoaded", function(){
    let doc = document.documentElement,
      w = window,
      prevScroll = w.scrollY || doc.scrollTop,
      curScroll,
      direction,
      prevDirection = 0,
      //header = $('#header .navbar');
      header = document.getElementById('header').getElementsByClassName('navbar123')[0];

    var checkScroll = function() {

      // Find the direction of scroll
      // 0 - initial, 1 - up, 2 - down
      curScroll = w.scrollY || doc.scrollTop;
      if (curScroll > prevScroll) {
        //scrolled up
        direction = 2;
      }
      else if (curScroll < prevScroll) {
        //scrolled down
        direction = 1;
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }

      prevScroll = curScroll;
    };

    var toggleHeader = function(direction, curScroll) {
      if (direction === 2 && curScroll > 120) {
        header.classList.remove('show');
        prevDirection = direction;
      }
      else if (direction === 1) {
        header.classList.add('show');
        prevDirection = direction;
      }
    };

    window.addEventListener('scroll', checkScroll);
  });
})();
*/
